//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";
import ordersCell from './orders-cell';

export default {
    name: 'orders-list',
    components: {
        emptyCell,
        ordersCell
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 10,
            refreshing: false,
            loading: false,
            finished: false,
            orders: [],
        };
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getOrders();
        },
        getOrders() {
            if (!localStorage.getItem('MemberId') || parseInt(localStorage.getItem('MemberId')) <= 0) {
                return
            }
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var params = {
                orderStatus: this.status,
                memberId: parseInt(localStorage.getItem('MemberId')),
                filter: '',
                sorting: '',
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            if (this.status === 9) {
                params.orderStatus = '';
            }
            abp.ajax.post('/api/services/app/Order/SearchOrders', params)
                .then(res => {
                    //console.log('items：%@', res.data.result.items);
                    if (this.pageIndex === 1) {
                        this.orders = [];
                    }
                    this.orders.push(...res.data.result.items);
                    if (res.data.result.items.length < this.pageSize) {
                        this.finished = true;
                    }
                })
                .catch(() => {
                })
                .then(() => {
                    this.refreshing = false;
                    this.loading = false;
                });
        }
    },
    props: {
        status: {
            type: Number,
            required: true
        }
    },
    created() {
        this.getOrders();
    }
};
